import { COMPENSATION_TYPE } from '../constants';

export const getCompensationAdornment = (compensationType: string | null) => {
  switch (compensationType) {
    case COMPENSATION_TYPE.YEARLY:
      return ' yearly';
    case COMPENSATION_TYPE.MONTHLY:
      return ' monthly';
    case COMPENSATION_TYPE.HOURLY:
      return ' hourly';
    default:
      return '';
  }
};
